import React from 'react';
import { Select } from '@nackle/paper';
import './icon-selector.less';
import IconLabel from './icon-label';
import * as icons from '@nackle/origami-icons';
export default class IconSelector extends React.Component {
  render() {
    const iconList = icons.default;
    const optionsArray = [];
    const makeOptionsArray = () => {
      iconList.map(icon => {
        const newName = icon.name.replace(/([A-Z])/g, ' $1').trim();
        const optionObject = {
          value: newName,
          label: /*#__PURE__*/React.createElement(IconLabel, {
            name: newName
          }, icon.component)
        };
        optionsArray.push(optionObject);
      });
    };
    const handleChange = value => {
      if (typeof this.props.onChange === 'function') {
        if (value) {
          this.props.onChange(value);
          this.setState({
            ...this.state,
            currentValue: value
          });
        } else {
          this.props.onChange('');
          this.setState({
            ...this.state,
            currentValue: ''
          });
        }
      }
    };
    const getCurrentValue = value => {
      const currentIcon = optionsArray.filter(option => option.value === value)[0];
      if (currentIcon) {
        return currentIcon.value;
      } else {
        return '';
      }
    };
    makeOptionsArray();
    return /*#__PURE__*/React.createElement(Select, {
      options: optionsArray,
      placeholder: 'Chose an icon',
      onChange: value => handleChange(value),
      defaultValue: getCurrentValue(this.props.currentIcon),
      allowClear: true,
      showSearch: true,
      name: 'icon-selector'
    });
  }
}
//# sourceMappingURL=icon-selector.js.map